/** Country phone prefix data — shared across auth, forms, and profile editors */

export interface CountryPhone {
  code: string; // ISO 3166-1 alpha-2 lowercase
  prefix: string; // E.164 prefix with +
  name: string; // English name for search
}

export const COUNTRY_PHONES: CountryPhone[] = [
  // ── Primary markets (listed first for quick access) ──
  { code: "ro", prefix: "+40", name: "Romania" },
  { code: "bg", prefix: "+359", name: "Bulgaria" },
  { code: "md", prefix: "+373", name: "Moldova" },
  { code: "de", prefix: "+49", name: "Germany" },
  { code: "hu", prefix: "+36", name: "Hungary" },
  { code: "gr", prefix: "+30", name: "Greece" },
  { code: "it", prefix: "+39", name: "Italy" },
  { code: "es", prefix: "+34", name: "Spain" },
  { code: "fr", prefix: "+33", name: "France" },
  { code: "gb", prefix: "+44", name: "United Kingdom" },

  // ── Rest of Europe (alphabetical) ──
  { code: "al", prefix: "+355", name: "Albania" },
  { code: "ad", prefix: "+376", name: "Andorra" },
  { code: "at", prefix: "+43", name: "Austria" },
  { code: "by", prefix: "+375", name: "Belarus" },
  { code: "be", prefix: "+32", name: "Belgium" },
  { code: "ba", prefix: "+387", name: "Bosnia and Herzegovina" },
  { code: "hr", prefix: "+385", name: "Croatia" },
  { code: "cy", prefix: "+357", name: "Cyprus" },
  { code: "cz", prefix: "+420", name: "Czech Republic" },
  { code: "dk", prefix: "+45", name: "Denmark" },
  { code: "ee", prefix: "+372", name: "Estonia" },
  { code: "fi", prefix: "+358", name: "Finland" },
  { code: "ge", prefix: "+995", name: "Georgia" },
  { code: "gi", prefix: "+350", name: "Gibraltar" },
  { code: "ie", prefix: "+353", name: "Ireland" },
  { code: "is", prefix: "+354", name: "Iceland" },
  { code: "xk", prefix: "+383", name: "Kosovo" },
  { code: "lv", prefix: "+371", name: "Latvia" },
  { code: "li", prefix: "+423", name: "Liechtenstein" },
  { code: "lt", prefix: "+370", name: "Lithuania" },
  { code: "lu", prefix: "+352", name: "Luxembourg" },
  { code: "mt", prefix: "+356", name: "Malta" },
  { code: "mc", prefix: "+377", name: "Monaco" },
  { code: "me", prefix: "+382", name: "Montenegro" },
  { code: "nl", prefix: "+31", name: "Netherlands" },
  { code: "mk", prefix: "+389", name: "North Macedonia" },
  { code: "no", prefix: "+47", name: "Norway" },
  { code: "pl", prefix: "+48", name: "Poland" },
  { code: "pt", prefix: "+351", name: "Portugal" },
  { code: "rs", prefix: "+381", name: "Serbia" },
  { code: "sk", prefix: "+421", name: "Slovakia" },
  { code: "si", prefix: "+386", name: "Slovenia" },
  { code: "se", prefix: "+46", name: "Sweden" },
  { code: "ch", prefix: "+41", name: "Switzerland" },
  { code: "tr", prefix: "+90", name: "Turkey" },
  { code: "ua", prefix: "+380", name: "Ukraine" },

  // ── Asia ──
  { code: "af", prefix: "+93", name: "Afghanistan" },
  { code: "am", prefix: "+374", name: "Armenia" },
  { code: "az", prefix: "+994", name: "Azerbaijan" },
  { code: "bh", prefix: "+973", name: "Bahrain" },
  { code: "bd", prefix: "+880", name: "Bangladesh" },
  { code: "bt", prefix: "+975", name: "Bhutan" },
  { code: "bn", prefix: "+673", name: "Brunei" },
  { code: "kh", prefix: "+855", name: "Cambodia" },
  { code: "cn", prefix: "+86", name: "China" },
  { code: "hk", prefix: "+852", name: "Hong Kong" },
  { code: "in", prefix: "+91", name: "India" },
  { code: "id", prefix: "+62", name: "Indonesia" },
  { code: "ir", prefix: "+98", name: "Iran" },
  { code: "iq", prefix: "+964", name: "Iraq" },
  { code: "il", prefix: "+972", name: "Israel" },
  { code: "jp", prefix: "+81", name: "Japan" },
  { code: "jo", prefix: "+962", name: "Jordan" },
  { code: "kz", prefix: "+7", name: "Kazakhstan" },
  { code: "kw", prefix: "+965", name: "Kuwait" },
  { code: "kg", prefix: "+996", name: "Kyrgyzstan" },
  { code: "la", prefix: "+856", name: "Laos" },
  { code: "lb", prefix: "+961", name: "Lebanon" },
  { code: "mo", prefix: "+853", name: "Macau" },
  { code: "my", prefix: "+60", name: "Malaysia" },
  { code: "mv", prefix: "+960", name: "Maldives" },
  { code: "mn", prefix: "+976", name: "Mongolia" },
  { code: "mm", prefix: "+95", name: "Myanmar" },
  { code: "np", prefix: "+977", name: "Nepal" },
  { code: "kp", prefix: "+850", name: "North Korea" },
  { code: "om", prefix: "+968", name: "Oman" },
  { code: "pk", prefix: "+92", name: "Pakistan" },
  { code: "ps", prefix: "+970", name: "Palestine" },
  { code: "ph", prefix: "+63", name: "Philippines" },
  { code: "qa", prefix: "+974", name: "Qatar" },
  { code: "ru", prefix: "+7", name: "Russia" },
  { code: "sa", prefix: "+966", name: "Saudi Arabia" },
  { code: "sg", prefix: "+65", name: "Singapore" },
  { code: "kr", prefix: "+82", name: "South Korea" },
  { code: "lk", prefix: "+94", name: "Sri Lanka" },
  { code: "sy", prefix: "+963", name: "Syria" },
  { code: "tw", prefix: "+886", name: "Taiwan" },
  { code: "tj", prefix: "+992", name: "Tajikistan" },
  { code: "th", prefix: "+66", name: "Thailand" },
  { code: "tl", prefix: "+670", name: "Timor-Leste" },
  { code: "tm", prefix: "+993", name: "Turkmenistan" },
  { code: "ae", prefix: "+971", name: "United Arab Emirates" },
  { code: "uz", prefix: "+998", name: "Uzbekistan" },
  { code: "vn", prefix: "+84", name: "Vietnam" },
  { code: "ye", prefix: "+967", name: "Yemen" },

  // ── Africa ──
  { code: "dz", prefix: "+213", name: "Algeria" },
  { code: "ao", prefix: "+244", name: "Angola" },
  { code: "bj", prefix: "+229", name: "Benin" },
  { code: "bw", prefix: "+267", name: "Botswana" },
  { code: "bf", prefix: "+226", name: "Burkina Faso" },
  { code: "bi", prefix: "+257", name: "Burundi" },
  { code: "cm", prefix: "+237", name: "Cameroon" },
  { code: "cv", prefix: "+238", name: "Cape Verde" },
  { code: "cf", prefix: "+236", name: "Central African Republic" },
  { code: "td", prefix: "+235", name: "Chad" },
  { code: "km", prefix: "+269", name: "Comoros" },
  { code: "cd", prefix: "+243", name: "Congo (DRC)" },
  { code: "cg", prefix: "+242", name: "Congo (Republic)" },
  { code: "ci", prefix: "+225", name: "Côte d'Ivoire" },
  { code: "dj", prefix: "+253", name: "Djibouti" },
  { code: "eg", prefix: "+20", name: "Egypt" },
  { code: "gq", prefix: "+240", name: "Equatorial Guinea" },
  { code: "er", prefix: "+291", name: "Eritrea" },
  { code: "sz", prefix: "+268", name: "Eswatini" },
  { code: "et", prefix: "+251", name: "Ethiopia" },
  { code: "ga", prefix: "+241", name: "Gabon" },
  { code: "gm", prefix: "+220", name: "Gambia" },
  { code: "gh", prefix: "+233", name: "Ghana" },
  { code: "gn", prefix: "+224", name: "Guinea" },
  { code: "gw", prefix: "+245", name: "Guinea-Bissau" },
  { code: "ke", prefix: "+254", name: "Kenya" },
  { code: "ls", prefix: "+266", name: "Lesotho" },
  { code: "lr", prefix: "+231", name: "Liberia" },
  { code: "ly", prefix: "+218", name: "Libya" },
  { code: "mg", prefix: "+261", name: "Madagascar" },
  { code: "mw", prefix: "+265", name: "Malawi" },
  { code: "ml", prefix: "+223", name: "Mali" },
  { code: "mr", prefix: "+222", name: "Mauritania" },
  { code: "mu", prefix: "+230", name: "Mauritius" },
  { code: "ma", prefix: "+212", name: "Morocco" },
  { code: "mz", prefix: "+258", name: "Mozambique" },
  { code: "na", prefix: "+264", name: "Namibia" },
  { code: "ne", prefix: "+227", name: "Niger" },
  { code: "ng", prefix: "+234", name: "Nigeria" },
  { code: "rw", prefix: "+250", name: "Rwanda" },
  { code: "sn", prefix: "+221", name: "Senegal" },
  { code: "sc", prefix: "+248", name: "Seychelles" },
  { code: "sl", prefix: "+232", name: "Sierra Leone" },
  { code: "so", prefix: "+252", name: "Somalia" },
  { code: "za", prefix: "+27", name: "South Africa" },
  { code: "ss", prefix: "+211", name: "South Sudan" },
  { code: "sd", prefix: "+249", name: "Sudan" },
  { code: "tz", prefix: "+255", name: "Tanzania" },
  { code: "tg", prefix: "+228", name: "Togo" },
  { code: "tn", prefix: "+216", name: "Tunisia" },
  { code: "ug", prefix: "+256", name: "Uganda" },
  { code: "zm", prefix: "+260", name: "Zambia" },
  { code: "zw", prefix: "+263", name: "Zimbabwe" },

  // ── Americas ──
  { code: "ar", prefix: "+54", name: "Argentina" },
  { code: "bo", prefix: "+591", name: "Bolivia" },
  { code: "br", prefix: "+55", name: "Brazil" },
  { code: "ca", prefix: "+1", name: "Canada" },
  { code: "cl", prefix: "+56", name: "Chile" },
  { code: "co", prefix: "+57", name: "Colombia" },
  { code: "cr", prefix: "+506", name: "Costa Rica" },
  { code: "cu", prefix: "+53", name: "Cuba" },
  { code: "do", prefix: "+1", name: "Dominican Republic" },
  { code: "ec", prefix: "+593", name: "Ecuador" },
  { code: "sv", prefix: "+503", name: "El Salvador" },
  { code: "gt", prefix: "+502", name: "Guatemala" },
  { code: "ht", prefix: "+509", name: "Haiti" },
  { code: "hn", prefix: "+504", name: "Honduras" },
  { code: "jm", prefix: "+1", name: "Jamaica" },
  { code: "mx", prefix: "+52", name: "Mexico" },
  { code: "ni", prefix: "+505", name: "Nicaragua" },
  { code: "pa", prefix: "+507", name: "Panama" },
  { code: "py", prefix: "+595", name: "Paraguay" },
  { code: "pe", prefix: "+51", name: "Peru" },
  { code: "pr", prefix: "+1", name: "Puerto Rico" },
  { code: "tt", prefix: "+1", name: "Trinidad and Tobago" },
  { code: "us", prefix: "+1", name: "United States" },
  { code: "uy", prefix: "+598", name: "Uruguay" },
  { code: "ve", prefix: "+58", name: "Venezuela" },

  // ── Oceania ──
  { code: "au", prefix: "+61", name: "Australia" },
  { code: "fj", prefix: "+679", name: "Fiji" },
  { code: "nz", prefix: "+64", name: "New Zealand" },
  { code: "pg", prefix: "+675", name: "Papua New Guinea" },
];

/** Quick lookup: country code → prefix string */
export const PHONE_PREFIX_MAP: Record<string, string> = Object.fromEntries(
  COUNTRY_PHONES.map((c) => [c.code, c.prefix]),
);

/** Convert ISO country code to flag emoji */
export function countryFlag(code: string): string {
  const upper = code.toUpperCase();
  if (upper === "XK") return "🇽🇰"; // Kosovo special case
  return String.fromCodePoint(...upper.split("").map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
}

/** Find a CountryPhone by code (case-insensitive), fallback to RO */
export function findCountryPhone(code: string | undefined): CountryPhone {
  const lower = (code || "ro").toLowerCase();
  return COUNTRY_PHONES.find((c) => c.code === lower) ?? COUNTRY_PHONES[0];
}
